<div class="container pt-5 my-5">
  <table class="table table-bordered">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Designation</th>
        <th scope="col">Member Name</th>
        <th scope="col">Contact Number</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th scope="row">1</th>
        <td>Sarapanch</td>
        <td>Malali Singh</td>
        <td>@mdo</td>
      </tr>
      <tr>
        <th scope="row">2</th>
        <td>PEO</td>
        <td>Prasanna Kumar Mohanty</td>
        <td>@fat</td>
      </tr>
      <tr>
        <th scope="row">3</th>
        <td>Jogan Sahayak</td>
        <td>Jagabandhu Das</td>
        <td>@fat</td>
      </tr>
      <tr>
        <th scope="row">4</th>
        <td>Gama Rojagar Sahayak</td>
        <td>Ajay Kumar Giri</td>
        <td>@fat</td>
      </tr>
      <tr>
        <th scope="row">5</th>
        <td>Self Employment Mechanisim</td>
        <td>Sudarsan Munda</td>
        <td>@fat</td>
      </tr>
      <tr>
        <th scope="row">6</th>
        <td>Panchayat Samit Member</td>
        <td>Susmita Mohanta</td>
        <td>@fat</td>
      </tr>
      <tr>
        <th scope="row">7</th>
        <td>Wardmember</td>
        <td>Manisankar Barik</td>
        <td>@fat</td>
      </tr>
      <tr>
        <th scope="row">8</th>
        <td>Wardmember</td>
        <td>Bijay Kumar Naik</td>
        <td>@fat</td>
      </tr>
      <tr>
        <th scope="row">9</th>
        <td>Wardmember</td>
        <td>Modhusmita Mohanta</td>
        <td>@fat</td>
      </tr>
      <tr>
        <th scope="row">10</th>
        <td>Wardmember</td>
        <td>Subhalaxmi Sethi</td>
        <td>@fat</td>
      </tr>
      <tr>
        <th scope="row">11</th>
        <td>Wardmember</td>
        <td>Raju Singh</td>
        <td>@fat</td>
      </tr>
      <tr>
        <th scope="row">12</th>
        <td>Wardmember</td>
        <td>Sukun Majhi</td>
        <td>@fat</td>
      </tr>
      <tr>
        <th scope="row">13</th>
        <td>Wardmember</td>
        <td>Rajoni Dehury</td>
        <td>@fat</td>
      </tr>
      <tr>
        <th scope="row">14</th>
        <td>Wardmember</td>
        <td>Bisikeshan Giri</td>
        <td>@fat</td>
      </tr>
    </tbody>
  </table>
</div>
